import React from 'react';

const OutlineBadge = ({children}) => (
  <div className={`
    ml-4
    py-1.5
    px-2
    hidden
    md:flex
    border
    border-gray-800
    text-gray-800
    rounded-md
    text-xs
    font-medium
    uppercase
    tracking-wider
    whitespace-nowrap
  `}
  >
    {children}
  </div>
);

export default OutlineBadge;
